export default __webpack_public_path__ + "static/media/copyicon.a419c6e5.svg";